import useFullscreenProps from './useFullscreenProps';
import useFunModeProps from './useFunModeProps';
import useGameOptionsProps from './useGameOptionsProps';
import useGameProps from './useGameProps';
import useGameSessionProps from './useGameSessionProps';
import useInGameCurrencyProps from './useInGameCurrencyProps';

const useGameContextProvider = () => {
  const { game, description } = useGameProps();
  const { isFunMode, setFunMode } = useFunModeProps(game);
  const { options, setOptions } = useGameOptionsProps();
  const inGameCurrencyProps = useInGameCurrencyProps(game);
  const gameSessionProps = useGameSessionProps({
    isFunMode,
    game,
    inGameCurrency: inGameCurrencyProps.inGameCurrency ?? undefined,
  });
  const fullscreenProps = useFullscreenProps();
  const value = {
    game,
    description,
    isFunMode,
    setFunMode,
    options,
    setOptions,
    ...inGameCurrencyProps,
    ...gameSessionProps,
    ...fullscreenProps,
  };
  return { value };
};
export default useGameContextProvider;
